import React, { useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { EmptyImage } from "../../assets/images";
import { useMutation } from "@apollo/client";
import { COMMUNITY_CREATE } from "../../apollo/operations";
import { useNavigate } from "react-router-dom";
import { PiPencilSimpleDuotone } from "react-icons/pi";
import { useSelector } from "react-redux";
import { handleIPFSUploadss } from "../../utils/iPfsUpload";

type CreateCommunityprrops = {
  handleClose: () => void;
  isRefetching?: () => void;
  toggle?: boolean | (() => void);
};
const CreateCommunity: React.FC<CreateCommunityprrops> = ({
  handleClose,
  isRefetching,
  toggle,
}) => {
  const [imageUpload, setImageUpload] = React.useState<string>();
  const [images, setImages] = React.useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [onChange, setOnChange] = React.useState(false);
  const userID = useSelector((state: any) => state.user.userDetails);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.trim(); // Trim whitespace from the input value
    setName(e.target.value); // Update the post state with the input value

    if (inputValue.trim().length > 0 || imageUpload?.length! > 0) {
      setOnChange(true); // Enable the button if there is non-whitespace content
    } else {
      setOnChange(false); // Disable the button if the content is empty or contains only whitespace
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const file = e.target.files?.[0];

    if (file) {
      setImages(file);
      setErrorMessage("");
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUpload(reader.result as string);
      };

      reader.readAsDataURL(file);
    } else {
      setImages(null);
      setErrorMessage("Please select a file");
    }
  };
  const navigate = useNavigate();

  const [createCommunity, { loading }] = useMutation(COMMUNITY_CREATE, {
    onCompleted(data) {
      if (isRefetching) {
        isRefetching();
        navigate("/ecobook/my-communities");
      }
    },
    onError: (err) => {
      console.log(err);
      const errorMsg = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMsg);
    },
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!images) {
      setErrorMessage("Please select a file");
      return;
    }
    if (userID) {
      setOnChange(false);
      handleIPFSUploadss(images)
        .then((ipfsHashes) => {
          createCommunity({
            variables: {
              data: {
                name: name,
                creator: { id: userID.id },
                description: description,
                communityHeaderImgUrl: ipfsHashes,
                members: {
                  connect: [
                    {
                      id: userID.id,
                    },
                  ],
                },
              },
            },
          });
        })
        .then(() => {
          if (typeof toggle === "function") {
            toggle();
          }
        });
    }
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleIconClick = () => {
    fileInputRef.current!.click();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-filter backdrop-blur-[10px] bg-[#FFFFFFC2] overflow-y-hidden">
      <div className=" flex flex-col rounded-lg lg:w-[25%] mt-10 h-[90%] px-3 lg:h-auto shadow-lg bg-white py-8 items-center">
        <div className="flex relative items-center justify-center w-full">
          <h3 className=" font-Poppins font-semibold text-[15px] text-black">
            Create Community
          </h3>
          <button
            className="py-2 px-2
          rounded-full text-[#33363F]
          bg-[#ECE6E6] active:bg-bgGrey
          hover:text-gray-600 absolute right-0"
          >
            {""}
            <AiOutlineClose size={20} onClick={handleClose} />
          </button>
        </div>
        <form
          className="w-full flex flex-col items-center"
          onSubmit={handleSubmit}
        >
          <div className="w-full flex h-[78px] relative mt-11 items-center justify-center">
            {imageUpload ? (
              <div className="h-[78px] w-[78px] relative rounded-full border-2 border-solid border-black">
                <img
                  src={imageUpload}
                  alt=""
                  className="h-[75px] w-[76px] rounded-full object-center"
                />
                <div className="absolute right-[1px] cursor-pointer bottom-0 w-[18px] h-[18px] shadow-sm flex items-center justify-center rounded-full bg-greyEdit outline outline-[3px] outline-comPagBg">
                  <PiPencilSimpleDuotone size={10} onClick={handleIconClick} />
                </div>
              </div>
            ) : (
              <img
                src={EmptyImage}
                alt=""
                className="cursor-pointer"
                onClick={handleIconClick}
              />
            )}
            <input
              type="file"
              title="."
              ref={fileInputRef}
              onChange={handleImageChange}
              className="invisible hidden"
            />
            {errorMessage && (
              <p
                className="absolute bottom-[-20px] font-Poppins text-xs"
                style={{ color: "red" }}
              >
                {errorMessage}
              </p>
            )}
          </div>
          <div className="w-full mt-11">
            <h1 className="font-Poppins font-semibold text-black text-[20px] mb-3">
              Name
            </h1>
            <input
              type="text"
              placeholder="Community name"
              value={name}
              onChange={handleOnChange}
              required
              disabled={loading}
              className="bg-[#E5F9EF] h-[41.72px] p-4 placeholder:text-[10.09px] placeholder:text-[#8E9297] rounded-sm outline-none w-full disabled:overflow-y-hidden disabled:bg-blend-overlay disabled:bg-black/20"
            />
          </div>
          <div className="w-full mt-8 mb-8">
            <h1 className="font-Poppins font-semibold text-black text-[20px] mb-3">
              Description
            </h1>
            <textarea
              value={description}
              placeholder="Community description"
              disabled={loading}
              onChange={(e) => setDescription(e.target.value)}
              className="bg-[#E5F9EF] disabled:overflow-y-hidden disabled:bg-blend-overlay resize-none h-[89.28px] p-4 placeholder:text-[10.09px] placeholder:text-[#8E9297] rounded-sm outline-none w-full"
            />
          </div>
          <button
            className={`w-[221px] flex items-center justify-center rounded-md h-11 text-[15px] font-Poppins font-semibold ${
              onChange
                ? "bg-midGreen text-white cursor-pointer"
                : "bg-[#E9E9E9] text-[#AEAFB4] cursor-not-allowed"
            }`}
          >
            Create Community
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateCommunity;
